import { render, staticRenderFns } from "./settingCompanyProject.vue?vue&type=template&id=48873323&scoped=true&"
import script from "./settingCompanyProject.vue?vue&type=script&lang=js&"
export * from "./settingCompanyProject.vue?vue&type=script&lang=js&"
import style0 from "./settingCompanyProject.vue?vue&type=style&index=0&id=48873323&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48873323",
  null
  
)

export default component.exports